<template>
    <div style="margin: 0; padding: 0;top:0; position:relative" id="app">
        <TagMain />
        <BPopup />
        <BPopup2 />
        <ClassStudentSelectAddDialog />
    </div>
</template>

<script>
    import TagMain from "./components/TagMain";
    import BPopup from "../components2/BPopup";
    import BPopup2 from "../components2/BPopup2";
    import ClassStudentSelectAddDialog from "../views/business/popComponents/ClassStudentSelectAddDialog";

    export default {
        name: "Home",
        components:{
            BPopup,
            BPopup2,
            TagMain,
            ClassStudentSelectAddDialog
        }
    }
</script>

<style>

    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    #app .dropdown-check-list ul.items li:hover {
        background: #0171A3;
        color: white;
        border-radius: 3px;
    }

    #app .dropdown-check-list ul.items li:hover .label-style {
        color: white;
    }
</style>